import { FaWhatsapp } from "react-icons/fa";
import { useTenant } from "../../Contexts/TenantContext";
import { unformat } from "../../Utils/DataFormatters";

const WhatsAppButton = () => {
  const { tenantContact } = useTenant();

  const message = "Olá, gostaria de ajuda!";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/${unformat(tenantContact.whatsAppNumber || "")}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-40 flex items-center justify-center w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition-colors duration-200"
      title={"Fale conosco no WhatsApp"}
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default WhatsAppButton;
